/*
 * Authors: mariushirjanu
 * Created: 31/05/2022
 */
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { STATE_INVOICE_ORDERFEES } from '../../shared/app-states';
import { IObject } from '../../../type_definitions/datatypes';
import { Transition } from '@uirouter/angular';
import { BodyClassService } from '../../shared/services/body-class.service';
import { GaWizard } from '../../shared/wizard/ga-wizard';
import { GaWizardService } from '../../shared/wizard/ga-wizard.service';
import { OrderFeesComponent } from './order-fees/order-fees.component';

export const ORDER_FEES_WIZARD:string = 'orderfees';

@Component({
  selector: 'invoice',
  template: `
    <wizard-wrapper [wizardTitle]="title" [error]="error" [loading]="loading" [wizardId]="wizardId">
  </wizard-wrapper>
  `
})
export class InvoiceComponent implements OnInit, OnDestroy {
  @Input() public invoiceId:number;
  private wizard:GaWizard;
  public title:string;
  public error:string;
  public loading:string;
  public wizardId:string = ORDER_FEES_WIZARD;

  constructor(
    private bodyClassService:BodyClassService,
    private transition:Transition,
    private wizardService:GaWizardService
  ) {
    bodyClassService.add('invoice');
  }

  public ngOnInit():void {
    this.wizard = this.wizardService.getInstance(ORDER_FEES_WIZARD);
    this.initWizard();
  }

  private initWizard() {
    const params:IObject = this.transition.params();

    this.wizard.steps([
      this.wizardService.createStep('orderfees', 'INVOICE.HEADINGS.ORDER_FEES', OrderFeesComponent, STATE_INVOICE_ORDERFEES, params, undefined, true)
    ]);
    this.wizard.sync();
  }

  public ngOnDestroy():void {
    this.wizard.clear();
  }
}